import { gql } from "@apollo/client";

export const QUERY_DISTRICT_METRICS_REPORT = gql`
  query (
      $districtIds: [ID], 
      $selectedFields: [String],
    ) {
    districtMetricsReport(
      districtIds: $districtIds, 
      selectedFields: $selectedFields
    ) {
      success
      message
      reportDataJson
    }
  }
`;
